"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishStatus = exports.Priority = exports.Remote = exports.Contract = exports.WorkType = exports.Source = exports.Languages = void 0;
exports.Languages = {
    ITALIAN: 'IT',
    ENGLISH: 'EN',
    SPANISH: 'ES',
    GERMAN: 'DE'
};
exports.Source = {
    TALENT: 'Talent Pro',
    JOB_BOARD: 'Talent'
};
exports.WorkType = {
    FULL_TIME: 'Full time',
    PART_TIME: 'Part time'
};
exports.Contract = {
    PERMANENT: 'Tempo indeterminato',
    CONSULTING: 'Consulenza freelance',
    FREELANCE: 'Progetto freelance'
};
exports.Remote = {
    FULL_REMOTE: 'Full remote',
    HYBRID: 'Hybrid',
    ON_SITE: 'On-site'
};
exports.Priority = {
    HIGH: 'High',
    MIDDLE: 'Middle',
    LOW: 'Low'
};
exports.PublishStatus = {
    PUBLISHED: 'published',
    DRAFT: 'draft',
    REVIEW: 'review',
    ARCHIVED: 'archived'
};
//# sourceMappingURL=const.js.map